import { React } from 'react';
import { Flex, Box, Text } from '@chakra-ui/react';

function GreyTextBox({ title, text, textBold = false }) {
  return (
    <Flex pb='9px'>
      <Box mr='14px'>
        <Text fontWeight='700' textAlign='right' width='210px'>
          {title}
        </Text>
      </Box>
      <Box>
        <Text fontWeight={`${textBold ? '700' : '400'}`}>{text}</Text>
      </Box>
    </Flex>
  );
}

export default GreyTextBox;
